import { render, staticRenderFns } from "./SetUpMyCard.vue?vue&type=template&id=67aff90a&"
import script from "./SetUpMyCard.vue?vue&type=script&lang=js&"
export * from "./SetUpMyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports